import { z } from 'zod';

// Timestamp schema tolerant of Firestore Timestamp objects, Unix numbers and
// ISO strings — mirrors the TimestampSchema in issueSchema.js and the toMs()
// helper in unitSection.js that already handles all three shapes.
const TimestampSchema = z.union([
  z.date(),
  z.object({
    seconds: z.number(),
    nanoseconds: z.number()
  }),
  z.string(),
  z.number(),
  z.null()
]);

// Validates docs from the Firestore `osiris/{unitId}/kpod_historic/{kpodId}`
// subcollection, written by Osiris' analytics.py (installation, total_usages).
export const KpodHistoricSchema = z.object({
  installation: TimestampSchema.optional(),
  total_usages: z.number().optional()
}).passthrough();

// Type inference
export type KpodHistoric = z.infer<typeof KpodHistoricSchema>;

/**
 * Validates if an object matches the KpodHistoric schema
 * @param {any} kpodHistoric - The kpod historic entry to validate
 * @returns {boolean} - True if the entry is valid
 */
export const validateKpodHistoric = (kpodHistoric) => {
  try {
    KpodHistoricSchema.parse(kpodHistoric);
    return true;
  } catch (error) {
    console.group('🚨 Kpod Historic Validation Failed');
    console.log('Kpod historic data:', kpodHistoric);
    console.log('Validation errors:', error.issues || error.errors);
    console.groupEnd();
    return false;
  }
};
